// import { ToastComponent } from "./../../components/toast/toast";
import { User } from "./../user/user";
import { Injectable, Injector, ViewChild } from "@angular/core";

@Injectable()
export class WebPushNotificationsService {
  private messaging: firebase.messaging.Messaging;
  // private toastComponent?: ToastComponent;

  constructor(private user: User, private injector: Injector) {
    const firebaseConfig = {
      apiKey: "AIzaSyAApBBqJd0VIc3g0Z_6jvSAHbszQI-M1Ck",
      authDomain: "matchabout-e39a6.firebaseapp.com",
      databaseURL: "https://matchabout-e39a6.firebaseio.com",
      projectId: "matchabout-e39a6",
      storageBucket: "matchabout-e39a6.appspot.com",
      messagingSenderId: "70810195268",
      appId: "1:70810195268:web:86609d50f99a54eb583311",
      measurementId: "G-C046YVGT13",
    };

    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }

    this.messaging = firebase.messaging();
  }

  requestPermissionAndGetToken() {
    this.messaging
      .requestPermission()
      .then(() => this.messaging.getToken())
      .then((token) => {
        console.log("Get Token:", token);
        if (token) {
          this.saveToken(token);
          this.getMessage();
        }
      })
      .catch((error) => console.error("Permission denied", error));
  }

  saveToken(token) {
    this.user.storeDeviceToken(token).subscribe(
      () => {
        console.log("ASSIGNED TO TOKEN", token);
      },
      (err) => {
        console.log("ERRORED OUT", err);
      }
    );
  }

  getMessage() {
    this.messaging.onMessage((payload) => {
      console.log("Primljena poruka", payload);
      payload.data={};
      const notificationTitle = payload.notification.title;
      const notificationOptions = {
          body: payload.notification.body,
          icon: "assets/imgs/webpush.png",
          badge: "assets/imgs/webpush.png",
        };
      // this.showNotification(notificationTitle, notificationBody);
    });
  }

  // setToastComponent(toast: ToastComponent) {
  //   this.toastComponent = toast;
  // }

  // showNotification(title: string, body: string) {
  //   if (this.toastComponent) {
  //     this.toastComponent.show(title, body);
  //   } else {
  //     console.error("ToastComponent nije inicijalizovan");
  //   }
  // }
}



// WEBPACK FOOTER //
// ./src/providers/web-push/web-push-notifications.service.ts